import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AuthInterceptor } from './app/services/shared/auth.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
 
bootstrapApplication(AppComponent, {
  ...appConfig, // spread existing appConfig
  providers: [
    ...(appConfig.providers || []), // include any existing providers from appConfig
    provideHttpClient(
      withInterceptors([AuthInterceptor])
    )
  ]
}).catch((err) => console.error(err));
